export default __webpack_public_path__ + "static/media/6.ab9e0b39.jpg";